import { Outlet, createRootRouteWithContext } from '@tanstack/react-router';
import type { RouterContext } from '@/router';

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootComponent,
  notFoundComponent: NotFound,
  errorComponent: ErrorBoundary,
});

function RootComponent() {
  return <Outlet />;
}

function NotFound() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-bg p-8 text-text">
      <div className="max-w-md space-y-2 text-center">
        <h1 className="text-2xl font-medium">Page not found</h1>
        <p className="text-sm text-text-muted">The route you requested does not exist.</p>
      </div>
    </div>
  );
}

function ErrorBoundary({ error }: { error: Error }) {
  return (
    <div className="flex min-h-screen items-center justify-center bg-bg p-8 text-text">
      <div className="max-w-md space-y-2 text-center">
        <h1 className="text-2xl font-medium">Something went wrong</h1>
        <p className="text-sm text-text-muted">{error.message}</p>
      </div>
    </div>
  );
}
